import React, { useState, useEffect } from 'react';
import fhirApiService from '../services/fhirApi';

const FhirApiTest = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [patients, setPatients] = useState([]);
  const [testResults, setTestResults] = useState({
    patientSearch: null,
    encounterSearch: null,
    observationSearch: null
  });

  const runTests = async () => {
    setLoading(true);
    setError(null);
    const results = {};

    try {
      // Test Patient Search
      const patientResponse = await fhirApiService.searchPatients({ _count: 5 });
      results.patientSearch = {
        success: true,
        count: patientResponse.total || 0,
        data: patientResponse.entry || []
      };
      setPatients(patientResponse.entry?.map(e => e.resource) || []);

      // Test Encounter Search
      const encounterResponse = await fhirApiService.searchEncounters({ _count: 5 });
      results.encounterSearch = {
        success: true,
        count: encounterResponse.total || 0,
        data: encounterResponse.entry || []
      };

      // Test Observation Search
      const observationResponse = await fhirApiService.searchObservations({ _count: 5 });
      results.observationSearch = {
        success: true,
        count: observationResponse.total || 0,
        data: observationResponse.entry || []
      };

      setTestResults(results);
    } catch (err) {
      setError(err.message || 'An error occurred during testing');
      console.error('FHIR API Test Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">FHIR API Integration Test</h2>
      
      <button
        onClick={runTests}
        disabled={loading}
        className="bg-blue-500 text-white px-4 py-2 rounded disabled:bg-gray-400"
      >
        {loading ? 'Running Tests...' : 'Run API Tests'}
      </button>

      {error && (
        <div className="mt-4 p-4 bg-red-100 text-red-700 rounded">
          Error: {error}
        </div>
      )}

      {Object.entries(testResults).map(([test, result]) => (
        result && (
          <div key={test} className="mt-4 p-4 bg-gray-50 rounded">
            <h3 className="font-semibold capitalize">{test.replace('Search', ' Search')}</h3>
            <div className="mt-2">
              <p>Status: {result.success ? '✅ Success' : '❌ Failed'}</p>
              <p>Count: {result.count}</p>
              {result.data.length > 0 && (
                <div className="mt-2">
                  <p className="font-semibold">Sample Data:</p>
                  <pre className="mt-1 p-2 bg-gray-100 rounded overflow-x-auto">
                    {JSON.stringify(result.data[0], null, 2)}
                  </pre>
                </div>
              )}
            </div>
          </div>
        )
      ))}

      {patients.length > 0 && (
        <div className="mt-6">
          <h3 className="text-xl font-semibold mb-2">Patient List</h3>
          <div className="grid gap-4">
            {patients.map(patient => (
              <div key={patient.id} className="p-4 bg-white shadow rounded">
                <h4 className="font-semibold">
                  {patient.name?.[0]?.given?.join(' ')} {patient.name?.[0]?.family}
                </h4>
                <p className="text-gray-600">ID: {patient.id}</p>
                <p className="text-gray-600">DOB: {patient.birthDate}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FhirApiTest; 